import { Component, Input, Output, EventEmitter, inject, OnChanges, SimpleChanges } from '@angular/core';
import { EhrConsultNoteReference } from 'app/core/models/ehr-consult-note-reference.model';
import { EhrConsultNoteReferencesService } from 'app/core/services/ehr-consult-note-references.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { EhrConsultNoteReferenceFormComponent } from '../ehr-consult-note-reference-form/ehr-consult-note-reference-form.component';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';
import { AuthenticationService } from 'app/core/services/authentication.service';
import { UserRoleName } from 'app/core/enums/user-role-name.enum';

@Component({
  selector: 'app-ehr-consult-note-reference',
  templateUrl: './ehr-consult-note-reference.component.html',
  styleUrls: ['./ehr-consult-note-reference.component.scss'],
  imports: [EhrConsultNoteReferenceFormComponent, DatePipe, BlankValueDashPipe]
})
export class EhrConsultNoteReferenceComponent implements OnChanges {
  private ehrConsultNoteReferencesService = inject(EhrConsultNoteReferencesService);
  private authService = inject(AuthenticationService);

  @Input() ehrConsultNoteReference: EhrConsultNoteReference;
  @Output() referenceUpdated = new EventEmitter<EhrConsultNoteReference>();

  editable = false;
  editing = false;
  ehrConsultNoteReferenceErrors: any;

  ngOnChanges(_changes: SimpleChanges): void {
    this.editable = !this.ehrConsultNoteReference.frozen ||
      this.authService.hasPermissionTo(UserRoleName.editVerifiedCaptures);
  }

  onEditClick() {
    this.editing = true;
  }

  onEditCanceled() {
    this.editing = false;
  }

  onEditSaved(formData: any) {
    this.ehrConsultNoteReferencesService.
      update(this.ehrConsultNoteReference.id, formData).
      subscribe({
        next: (updatedEhrConsultNoteReference: EhrConsultNoteReference) => {
          this.referenceUpdated.emit(updatedEhrConsultNoteReference);
          this.editing = false;
        },
        error: (response: HttpErrorResponse) => {
          if (response.status === 400) {
            this.ehrConsultNoteReferenceErrors = response.error.errors;
          } else {
            console.error(response);
          }
        }
      });
  }
}
